export var DraftGptLanguage;
(function (DraftGptLanguage) {
    DraftGptLanguage["DANISH"] = "da-DK";
    DraftGptLanguage["DUTCH"] = "nl-NL";
    DraftGptLanguage["ENGLISH"] = "en-GB";
    DraftGptLanguage["FINNISH"] = "fi-FI";
    DraftGptLanguage["FRENCH"] = "fr-FR";
    DraftGptLanguage["GERMAN"] = "de-DE";
    DraftGptLanguage["LATVIAN"] = "lv-LV";
    DraftGptLanguage["LITHUANIAN"] = "lt-LT";
    DraftGptLanguage["POLISH"] = "pl-PL";
    DraftGptLanguage["SPANISH"] = "es-ES";
    DraftGptLanguage["SWEDISH"] = "sv-SE";
})(DraftGptLanguage || (DraftGptLanguage = {}));
export function getDraftGptLanguageByValue(value) {
    var keys = Object.keys(DraftGptLanguage).filter(function (entry) { return DraftGptLanguage[entry] == value; });
    return keys[0];
}
export var gptDraftLanguages = {
    FINNISH: {
        key: DraftGptLanguage.FINNISH,
        label: 'common.locales.finnish',
        flag: '🇫🇮',
    },
    ENGLISH: {
        key: DraftGptLanguage.ENGLISH,
        label: 'common.locales.english',
        flag: '🇺🇸',
    },
    LATVIAN: {
        key: DraftGptLanguage.LATVIAN,
        label: 'common.locales.latvian',
        flag: '🇱🇻',
    },
    GERMAN: {
        key: DraftGptLanguage.GERMAN,
        label: 'common.locales.german',
        flag: '🇩🇪',
    },
    DUTCH: {
        key: DraftGptLanguage.DUTCH,
        label: 'common.locales.dutch',
        flag: '🇳🇱',
    },
    LITHUANIAN: {
        key: DraftGptLanguage.LITHUANIAN,
        label: 'common.locales.lithuanian',
        flag: '🇱🇹',
    },
    POLISH: {
        key: DraftGptLanguage.POLISH,
        label: 'common.locales.polish',
        flag: '🇵🇱',
    },
    FRENCH: {
        key: DraftGptLanguage.FRENCH,
        label: 'common.locales.french',
        flag: '🇫🇷',
    },
    SPANISH: {
        key: DraftGptLanguage.SPANISH,
        label: 'common.locales.spanish',
        flag: '🇪🇸',
    },
    DANISH: {
        key: DraftGptLanguage.DANISH,
        label: 'common.locales.danish',
        flag: '🇩🇰',
    },
    SWEDISH: {
        key: DraftGptLanguage.SWEDISH,
        label: 'common.locales.swedish',
        flag: '🇸🇪',
    },
};
